import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { IoMdClose } from "react-icons/io";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { useEffect, useRef, useState } from "react";
import { LabeledInputFull } from "../../../UI/LabeledInputFull";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import { useTextareaOverflow } from "../../../novos/Budget/ServiceItem";

interface ObservationsModalProps {
  isOpen: boolean;
  onClose: () => void;
  serviceObservations: string;
  onChange(value: string): void;
  onConfirm(): void;
}

const ObservationsModal = ({
  onClose,
  isOpen,
  serviceObservations,
  onChange,
  onConfirm,
}: ObservationsModalProps) => {
  const [draft, setDraft] = useState<string | null>(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const prevIsOpenRef = useRef(false);

  useEffect(() => {
    if (isOpen) {
      if (!prevIsOpenRef.current) {
        setDraft(serviceObservations);
      }
      prevIsOpenRef.current = true;
    } else {
      setDraft(null);
      setIsExpanded(false);
      prevIsOpenRef.current = false;
    }
  }, [isOpen, serviceObservations]);

  const hasOverflow = useTextareaOverflow(textareaRef, serviceObservations);

  const handleClose = () => {
    if (draft !== null) {
      onChange(draft);
    }
    setDraft(null);
    setIsExpanded(false);
    onClose();
  };

  const handleConfirm = () => {
    onConfirm();
    setDraft(null);
    setIsExpanded(false);
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={isOpen} fullWidth maxWidth={"sm"}>
      <DialogTitle sx={{ m: 0, px: 4, color: "#4B465C" }}>
        Observações Internas
      </DialogTitle>

      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 16,
          top: 16,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <IoMdClose />
      </IconButton>

      <DialogContent sx={{ px: 4 }}>
        <Box display={"flex"} flexDirection={"column"} gap={2}>
          <LabeledInputFull
            label="Informe as observações internas deste serviço"
            value={serviceObservations}
            placeholder="Especifique"
            multiline
            maxRows={isExpanded ? 25 : 1}
            inputRef={textareaRef}
            onChange={(e) => {
              setDraft(e.target.value);
              onChange(e.target.value);
            }}
            onFocus={() => setIsExpanded(true)}
            onBlur={() => setIsExpanded(false)}
            endAdornment={
              hasOverflow && serviceObservations?.trim() ? (
                isExpanded ? (
                  <MdExpandLess
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => {
                      textareaRef.current?.blur();
                      setIsExpanded(false);
                    }}
                  />
                ) : (
                  <MdExpandMore
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => setIsExpanded(true)}
                  />
                )
              ) : null
            }
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 4, py: 3 }}>
        <Button onClick={handleClose} variant="outlined">
          Cancelar
        </Button>
        <Button onClick={handleConfirm}>Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ObservationsModal;
